// 开始时间
export function getkstime(data) {
    var tims = data;
    if (tims == 20) {
        tims = 28800
    } else if (tims == 24) {
        tims = 1440
    } else if (tims == 3) {
        tims = 30
    } else if (tims == 1) {
        tims = 1
    } else if (tims == 2880) {
        tims = 2880
    } else {
        tims = 180
    }
    var date = new Date(); //1. js获取当前时间
    var min = date.getMinutes(); //2. 获取当前分钟
    date.setMinutes(min - tims); //3. 设置当前时间-5分钟：把当前分钟数-5后的值重新设置为date对象的分钟数
    var y = date.getFullYear();
    var m = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
    var d = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    var h = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    var f = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
    var s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
    var formatdate = y + "-" + m + "-" + d + " " + h + ":" + f + ":" + s;
    return formatdate;
}

// 结束时间
export function getjstime() {
    var now = new Date();
    var year = now.getFullYear(); //年
    var month = now.getMonth() + 1; //月
    var day = now.getDate(); //日
    var hh = now.getHours(); //时
    var mm = now.getMinutes(); //分
    var ss = now.getSeconds(); //分
    var clock = year + "-";
    if (month < 10) clock += "0";
    clock += month + "-";
    if (day < 10) clock += "0";
    clock += day + " ";
    if (hh < 10) clock += "0";
    clock += hh + ":";
    if (mm < 10) clock += "0";
    clock += mm + ":";
    if (ss < 10) clock += "0";
    return clock += ss;
}

// 获取当天时间
export function Timeofday() {
    var stamp1 = new Date(new Date().setHours(0, 0, 0, 0)); //获取当天零点的时间
    var stamp2 = new Date(new Date().setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000 - 1); //获取当天23:59:59的时间
    var d = new Date(stamp1);
    var tt = new Date(stamp2);
    var ksmm = d.getMonth() + 1
    if (ksmm < 10) {
        ksmm = '0' + ksmm
    }
    var ksdd = d.getDate();
    if (ksdd < 10) {
        ksdd = '0' + ksdd;
    }
    var jsmm = tt.getMonth() + 1
    if (jsmm < 10) {
        jsmm = '0' + jsmm
    }
    var jsdd = tt.getDate();
    if (jsdd < 10) {
        jsdd = '0' + jsdd;
    }
    var Startdatetime = d.getFullYear() + '-' + ksmm + '-' + ksdd + ' ' + d.getHours() + '0:' + d.getMinutes() + '0:' + d.getSeconds() + '0';
    var Enddatetime = tt.getFullYear() + '-' + jsmm + '-' + jsdd + ' ' + tt.getHours() + ':' + tt.getMinutes() + ':' + tt.getSeconds();
    var arr = [Startdatetime, Enddatetime];
    return arr;
}

/**
 * 通用js方法封装处理
 * Copyright (c) 2019 ruoyi
 */

// 日期格式化
export function parseTime(time, pattern) {
    if (arguments.length === 0 || !time) {
        return null
    }
    const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
        date = time
    } else {
        if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
            time = parseInt(time)
        } else if (typeof time === 'string') {
            time = time.replace(new RegExp(/-/gm), '/').replace('T', ' ').replace(new RegExp(/\.[\d]{3}/gm), '');
        }
        if ((typeof time === 'number') && (time.toString().length === 10)) {
            time = time * 1000
        }
        date = new Date(time)
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    }
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key]
        // Note: getDay() returns 0 on Sunday
        if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
        if (result.length > 0 && value < 10) {
            value = '0' + value
        }
        return value || 0

    })

    return time_str
}

// 表单重置
export function resetForm(refName) {
    if (this.$refs[refName]) {
        this.$refs[refName].resetFields();
    }
}

// 添加日期范围
export function addDateRange(params, dateRange, propName) {
    let search = params;
    search.params = typeof (search.params) === 'object' && search.params !== null && !Array.isArray(search.params) ? search.params : {};
    dateRange = Array.isArray(dateRange) ? dateRange : [];
    if (typeof (propName) === 'undefined') {
        search.params['beginTime'] = dateRange[0];
        search.params['endTime'] = dateRange[1];
    } else {
        search.params['begin' + propName] = dateRange[0];
        search.params['end' + propName] = dateRange[1];
    }
    return search;
}

// 回显数据字典
export function selectDictLabel(datas, value) {
    if (value === undefined) {
        return "";
    }
    var actions = [];
    Object.keys(datas).some((key) => {
        if (datas[key].value == ('' + value)) {
            actions.push(datas[key].label);
            return true;
        }
    })
    if (actions.length === 0) {
        actions.push(value);
    }
    return actions.join('');
}

// 回显数据字典（字符串数组）
export function selectDictLabels(datas, value, separator) {
    if (value === undefined) {
        return "";
    }
    var actions = [];
    var currentSeparator = undefined === separator ? "," : separator;
    var temp = value.split(currentSeparator);
    Object.keys(value.split(currentSeparator)).some((val) => {
        var match = false;
        Object.keys(datas).some((key) => {
            if (datas[key].value == ('' + temp[val])) {
                actions.push(datas[key].label + currentSeparator);
                match = true;
            }
        })
        if (!match) {
            actions.push(temp[val] + currentSeparator);
        }
    })
    return actions.join('').substring(0, actions.join('').length - 1);
}

// 字符串格式化(%s )
export function sprintf(str) {
    var args = arguments, flag = true, i = 1;
    str = str.replace(/%s/g, function () {
        var arg = args[i++];
        if (typeof arg === 'undefined') {
            flag = false;
            return '';
        }
        return arg;
    });
    return flag ? str : '';
}

// 转换字符串，undefined,null等转化为""
export function parseStrEmpty(str) {
    if (!str || str == "undefined" || str == "null") {
        return "";
    }
    return str;
}

// 数据合并
export function mergeRecursive(source, target) {
    for (var p in target) {
        try {
            if (target[p].constructor == Object) {
                source[p] = mergeRecursive(source[p], target[p]);
            } else {
                source[p] = target[p];
            }
        } catch (e) {
            source[p] = target[p];
        }
    }
    return source;
};

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 */
export function handleTree(data, id, parentId, children) {
    let config = {
        id: id || 'id',
        parentId: parentId || 'parentId',
        childrenList: children || 'children'
    };

    var childrenListMap = {};
    var nodeIds = {};
    var tree = [];

    for (let d of data) {
        let parentId = d[config.parentId];
        if (childrenListMap[parentId] == null) {
            childrenListMap[parentId] = [];
        }
        nodeIds[d[config.id]] = d;
        childrenListMap[parentId].push(d);
    }

    for (let d of data) {
        let parentId = d[config.parentId];
        if (nodeIds[parentId] == null) {
            tree.push(d);
        }
    }

    for (let t of tree) {
        adaptToChildrenList(t);
    }

    function adaptToChildrenList(o) {
        if (childrenListMap[o[config.id]] !== null) {
            o[config.childrenList] = childrenListMap[o[config.id]];
        }
        if (o[config.childrenList]) {
            for (let c of o[config.childrenList]) {
                adaptToChildrenList(c);
            }
        }
    }
    return tree;
}

/**
 * 参数处理
 * @param {*} params  参数
 */
export function tansParams(params) {
    let result = ''
    for (const propName of Object.keys(params)) {
        const value = params[propName];
        var part = encodeURIComponent(propName) + "=";
        if (value !== null && typeof (value) !== "undefined") {
            if (typeof value === 'object') {
                for (const key of Object.keys(value)) {
                    if (value[key] !== null && typeof (value[key]) !== 'undefined') {
                        let params = propName + '[' + key + ']';
                        var subPart = encodeURIComponent(params) + "=";
                        result += subPart + encodeURIComponent(value[key]) + "&";
                    }
                }
            } else {
                result += part + encodeURIComponent(value) + "&";
            }
        }
    }
    return result
}

// 验证是否为blob格式
export async function blobValidate(data) {
    try {
        const text = await data.text();
        JSON.parse(text);
        return false;
    } catch (error) {
        return true;
    }
}

export function numfix(num) {
    return num / 10000 >= 1
        ? (num / 10000).toFixed(1) + "w"
        : num / 1000 >= 1
            ? (num / 1000).toFixed(1) + "k"
            : num;
}

// 获取当前时间前一天
export function getYestoday() {
    var yesterday_milliseconds = new Date().getTime() - 1000 * 60 * 60 * 24;
    var yesterday = new Date();
    yesterday.setTime(yesterday_milliseconds);

    var strYear = yesterday.getFullYear();
    var strDay = yesterday.getDate() < 10 ? "0" + yesterday.getDate() : yesterday.getDate();
    var strMonth = yesterday.getMonth() + 1 < 10 ? "0" + (yesterday.getMonth() + 1) : yesterday.getMonth() + 1;
    var strHour = yesterday.getHours() < 10 ? "0" + yesterday.getHours() : yesterday.getHours();
    var strMin = yesterday.getMinutes() < 10 ? "0" + yesterday.getMinutes() : yesterday.getMinutes();
    var strSec = yesterday.getSeconds() < 10 ? "0" + yesterday.getSeconds() : yesterday.getSeconds();

    var datastr =
        strYear +
        "-" +
        strMonth +
        "-" +
        strDay +
        "  " +
        strHour +
        ":" +
        strMin +
        ":" +
        strSec;
    return datastr;
}
// 获取当前时间
export function getNow() {
    // var yesterday_milliseconds = date.getTime() - 1000 * 60 * 60 * 24;
    var yesterday = new Date();
    // yesterday.setTime(yesterday_milliseconds);

    var strYear = yesterday.getFullYear();
    var strDay = yesterday.getDate() < 10 ? "0" + yesterday.getDate() : yesterday.getDate();
    var strMonth = yesterday.getMonth() + 1 < 10 ? "0" + (yesterday.getMonth() + 1) : yesterday.getMonth() + 1;
    var strHour = yesterday.getHours() < 10 ? "0" + yesterday.getHours() : yesterday.getHours();
    var strMin = yesterday.getMinutes() < 10 ? "0" + yesterday.getMinutes() : yesterday.getMinutes();
    var strSec = yesterday.getSeconds() < 10 ? "0" + yesterday.getSeconds() : yesterday.getSeconds();

    var datastr1 =
        strYear +
        "-" +
        strMonth +
        "-" +
        strDay +
        " " +
        strHour +
        ":" +
        strMin +
        ":" +
        strSec;
    return datastr1;
}
// 获取15天时间
export function getFifthTime() {
    var yesterday_milliseconds = new Date().getTime() - 1000 * 60 * 60 * 24 * 15;
    var yesterday = new Date();
    yesterday.setTime(yesterday_milliseconds);

    var strYear = yesterday.getFullYear();
    var strDay = yesterday.getDate() < 10 ? "0" + yesterday.getDate() : yesterday.getDate();
    var strMonth = yesterday.getMonth() + 1 < 10 ? "0" + (yesterday.getMonth() + 1) : yesterday.getMonth() + 1;
    var strHour = yesterday.getHours() < 10 ? "0" + yesterday.getHours() : yesterday.getHours();
    var strMin = yesterday.getMinutes() < 10 ? "0" + yesterday.getMinutes() : yesterday.getMinutes();
    var strSec = yesterday.getSeconds() < 10 ? "0" + yesterday.getSeconds() : yesterday.getSeconds();

    var datastr =
        strYear +
        "-" +
        strMonth +
        "-" +
        strDay +
        "  " +
        strHour +
        ":" +
        strMin +
        ":" +
        strSec;
    return datastr;
}

/**
 * 参数处理
 * @param {*} dataArr  要处理的数组
 */
// 将按照时间返回的信号处理成时间段信号数据
export function signalData(dataArr) {
    let result = []
    for (let i = 1; i < dataArr.length; i++) {
        if (dataArr[i].value != dataArr[i - 1].value) {
            // console.log(i, "判断", dataArr[i]);
            result.push({
                index: i,
                ...dataArr[i]
            })
        }
    }
    let open = []
    if (result.length == 0) {
        open.push({
            name: dataArr[0].value == 0 ? "停机" : "运行",
            value: [dataArr[0].value, dataArr[0].createTime, dataArr[dataArr.length - 1].createTime],
            itemStyle: { normal: { color: dataArr[0].value == 0 ? "rgb(0,107,248) " : "rgb(0,253,53)" } }
        })
    } else {
        open = [{
            name: dataArr[0].value == 0 ? "停机" : "运行",
            value: [dataArr[0].value, dataArr[0].createTime, dataArr[result[0].index].createTime],
            itemStyle: { normal: { color: dataArr[0].value == 0 ? "rgb(0,107,248) " : "rgb(0,253,53)" } }
        }]
        for (let i = 0; i < result.length - 1; i++) {
            open.push({
                name: dataArr[result[i].index].value == 0 ? "停机" : "运行",
                value: [dataArr[result[i].index].value == 0 ? "停机" : "运行", dataArr[result[i].index].createTime, dataArr[result[i + 1].index].createTime],
                itemStyle: { normal: { color: dataArr[result[i].index].value == 0 ? "rgb(0,107,248) " : "rgb(0,253,53)" } }
            })
        }
        open.push({
            name: dataArr[dataArr.length - 1].value == 0 ? "停机" : "运行",
            value: [dataArr[dataArr.length - 1].value == 0 ? "停机" : "运行", dataArr[result[result.length - 1].index].createTime, dataArr[dataArr.length - 1].createTime],
            itemStyle: { normal: { color: dataArr[dataArr.length - 1].value == 0 ? "rgb(0,107,248) " : "rgb(0,253,53)" } }
        })
    }
    return open

}

// 将传入时间转换为 xxxx-xx-xx 的时间格式
export function getDate(dateStr) {
    let date = new Date(dateStr);
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    m = m < 10 ? '0' + m : m;
    let d = date.getDate();
    d = d < 10 ? '0' + d : d;
    var formatdate = y + '-' + m + '-' + d;
    return formatdate;
}
//获取地址栏参数
export function GetURL(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
}
export function getWxCallbackUrl() {
    // const AppId = window.global_url.AppId;
    const AppId = "wx194dba4d985bdcec";
    let local = window.location.protocol + "//" + window.location.host + '/';
    console.log('local------------>', local);
    let link = getURLParameter("p")
    // console.log("link--------------->", link);
    let wxurl = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + AppId +
        "&redirect_uri=" + encodeURIComponent(local) +
        "&response_type=code&scope=snsapi_userinfo&state=" + encodeURIComponent(link) + "#wechat_redirect";
    console.log(wxurl, "wxurl");
    return wxurl;
}
export function base64ToBlob(urlData, type) {
    let arr = urlData.split(',');
    let mime = arr[0].match(/:(.*?);/)[1] || type;
    // 去掉url的头，并转化为byte
    let bytes = window.atob(arr[1]);
    // 处理异常,将ascii码小于0的转换为大于0
    let ab = new ArrayBuffer(bytes.length);
    // 生成视图（直接针对内存）：8位无符号整数，长度1个字节
    let ia = new Uint8Array(ab);
    for (let i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
    }
    return new Blob([ab], {
        type: mime
    });
}









// WEBPACK FOOTER //
// ./src/utils/ruoyi.js